import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, shareReplay, take } from 'rxjs/operators';
import { merge, Observable } from 'rxjs';

@Injectable()
export class NavigationService {
    // order related properties and access methods related to them should
    // be moved to other service when we remove the NavigationService
    private orderBrandsExpanded = true;
    private orderCategoriesExpanded = false;

    constructor(
        private router: Router,
        private route: ActivatedRoute
    ) {}

    toggleOrderBrands() {
        this.orderBrandsExpanded = !this.orderBrandsExpanded;
    }

    toggleOrderCategories() {
        this.orderCategoriesExpanded = !this.orderCategoriesExpanded;
    }

    isOrderBrandsExpanded(): boolean {
        return this.orderBrandsExpanded;
    }

    isOrderCategoriesExpanded(): boolean {
        return this.orderCategoriesExpanded;
    }

    getNavigationChanges(): Observable<any> {
        const navigationEnd = this.router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            shareReplay(1)
        );

        const firstActivatedRoute = this.route.url.pipe(take(1));

        return merge(firstActivatedRoute, navigationEnd).pipe(shareReplay(1));
    }
}
